<template>
  <div class="editor-modal">
    <div class="editor-modal-backdrop"></div>
    <div class="editor-modal-inner">
      <div class="editor-modal-content" v-bind:style="{width: contentWidth+'px', height: contentHeight+'px'}">
        <editor-layout
          v-bind:foreground-type="this.foregroundType"
          v-bind:original-url="this.originalUrl"
          v-bind:foreground-url="this.foregroundUrl"
          v-bind:filename="this.filename"
          v-bind:locale="this.locale"
          v-bind:detect_objects_enabled="this.detect_objects_enabled"
          v-bind:resultId="this.resultId"
          v-bind:t="this.t"
          v-bind:signed_in="this.signed_in"
          v-on:loaded="updateSize"
          ref="editorLayout" />
      </div>
    </div>
  </div>
</template>

<script>
import EditorLayout from './editor_layout';

export default {
  props: {
    originalUrl: String,
    foregroundUrl: String,
    filename: String,
    foregroundType: String,
    locale: String,
    detect_objects_enabled: Boolean,
    resultId: String,
    signed_in: Boolean,
    t: Object,
  },
  components: { EditorLayout },
  data() {
    return {
      contentWidth: null,
      minContentWidth: 760,
      contentHeight: null,
      minContentHeight: 500,
    };
  },
  mounted() {
    this.contentWidth = this.minContentWidth;
    this.contentHeight = this.minContentHeight;
  },
  methods: {
    updateSize(e) {
      this.contentWidth = (e.width > this.minContentWidth ? e.width : this.minContentWidth);
      this.contentHeight = (e.height > this.minContentHeight ? e.height : this.minContentHeight);
      this.$nextTick(() => {
        this.$refs.editorLayout.zoomFit();
      })
    }
  }
}
</script>

<style scoped>
.editor-modal {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 15000;
}
.editor-modal-backdrop {
  background: #0b0b0b;
  opacity: 0.8;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 15010;
}
.editor-modal-inner {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 15020;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media(min-width: 768px) {
  .editor-modal-inner {
    padding: 15px;
  }
}
.editor-modal-content {
  background: #fff;
  position: relative;
}
@media(min-width: 768px) {
  .editor-modal-content {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
@media(max-width: 767px) {
  .editor-modal-content {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
